import { InjectionToken } from '@angular/core';

export const CORE_APP_CONFIG = new InjectionToken<any>('CORE_APP_CONFIG');
